import React from 'react';
import { EditIcon } from '../../../assets/icons';

export const ActionBox = ({
  id,
  lotNo,
  state,
  received_quantity,
  showEdit,
  setPopUp,
  setPopUpData,
  tracking,
  rolls,
  damaged_quantity,
}) => {
  return (
    <div className="td-num">
      {state !== 'Done' ? (
        <EditIcon
          onClick={(e) => {
            e.stopPropagation();
            setPopUp(true);
            setPopUpData({
              received_quantity,
              id,
              lotNo,
              tracking,
              showEdit,
              rolls,
              damaged_quantity,
            });
          }}
        />
      ) : (
        '-'
      )}
    </div>
  );
};
